import { BsClipboard2DataFill } from 'react-icons/bs';
import { FaExchangeAlt, FaShoppingBag } from 'react-icons/fa';
import { FaStore } from 'react-icons/fa6';
import { HiReceiptRefund } from 'react-icons/hi2';

import { routes } from 'commons';
import { MenuNavItem } from 'types';

const ORDER_TITLE = 'Pedidos';
const EXCHANGE_TITLE = 'Trocas e devoluções';
const ORDER_ATTENDANCE_TITLE = 'Meus Pedidos';

export const MENU_ITEMS: MenuNavItem[] = [
  {
    icon: <HiReceiptRefund size={24} />,
    title: 'Devoluções e estornos',
    isAdmin: true,
    isStore: false,
    itemList: [routes.returnsAndRefunds],
  },
  {
    icon: <BsClipboard2DataFill size={24} />,
    title: 'Relatório de transações Pix',
    isAdmin: true,
    isStore: false,
    itemList: [routes.pixTransactionsReport],
  },
  {
    icon: <FaShoppingBag size={24} />,
    title: ORDER_TITLE,
    isAdmin: false,
    isStore: true,
    itemList: [
      { name: ORDER_ATTENDANCE_TITLE, path: routes.dashboard.path },
      routes.batchCollection,
    ],
  },
  {
    icon: <FaStore size={24} />,
    title: 'Minha Loja',
    isAdmin: false,
    isStore: true,
    itemList: [
      routes.profile,
      routes.openingDays,
      routes.discount,
      routes.financialTransactions,
    ],
  },
  {
    icon: <FaExchangeAlt size={24} />,
    title: EXCHANGE_TITLE,
    isAdmin: false,
    isStore: true,
    itemList: [routes.exchangeReturnForm, routes.exchangeAndReturn],
  },
  {
    icon: <BsClipboard2DataFill size={24} />,
    title: 'Relatórios',
    isAdmin: false,
    isStore: true,
    itemList: [routes.performance, routes.scoreReport],
  },
];

export { EXCHANGE_TITLE, ORDER_ATTENDANCE_TITLE, ORDER_TITLE };
